import React from "react";
import { Card, Image } from "antd";
import PageHeader from "../../components/headers/PageHeader";
import logoApp from "../../assets/Xinerlink.png";
import LoginForm from "./components/LoginForm";

export default function LoginPage() {
    return (
        <div className="max-w-md mx-auto">
            <div className="w-56 mx-auto mb-4">
                <Image src={logoApp} preview={false} alt="Logo App" />
            </div>
            <Card>
                <PageHeader
                    head="Plataforma Dirección de Trabajo"
                    title="Iniciar Sesión"
                />
                <LoginForm />
            </Card>
        </div>
    );
}
